import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import LogoFallback from "/assets/img/bubbanlogo.jpg";
import axios from "axios";

export default function BbaPage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Bachelor of Business Administration | Program | Bandarban University",
}) {
	const [data, setData] = useState({});
	const [openSemester, setOpenSemester] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	
	const coursePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"2",
				programme_id:"1",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/program-syllabus", payload);
			
			setData(response.data || []);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		coursePost();		
	}, []);
	
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	
	const toggleSemester = (sem) => {
		setOpenSemester(openSemester === sem ? null : sem);
	};
	
	const program = {
		program:"Bachelor of Business Administration",
		duration:"4 Years",
		semester:"8",
		credit:"141 (Foundation: 12, GED/Allied:30, Core:78)",
		admission:"10000 (Once)",
		semester_fee:"5000 (Per Semester)",
		establihsment:"2000 (Per Semester)",
		library:"100 (Once)",
		lab:"500 (Per Semester)",
		exam:"100 (Per Credit)",
		tuition:"1382 (Per Credit)",
		total:"2,79,962/=",
	};
	const fadeUp = {
		hidden: { opacity: 0, y: 40 },
		visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
	};
	const [openPLO, setOpenPLO] = useState(null);

	const plos = [
		{ title: "Fundamental", text: "Develop fundamental in-depth knowledge and understanding of the principles, concepts, values, substantive rules and development of the core areas of business such as management, finance, accounting, marketing, HR operations." },
		{ title: "Administration", text: "Expertise their skill in the efficient administration of the organization through effective utilization of available resources to yield maximum productivity in the organization." },
		{ title: "Multidimensional", text: "Understand multidimensional business environments, policy, protocols, and ethical management practices required within national and the global context." },
		{ title: "Adapting to change", text: "Recognize the need for adapting to change and have the aptitude and ability to engage in independent and life – long learning in the broadest context of socio-economic, technological and global change." },
		{ title: "Exposure in Marketing", text: "Acquire in-depth & broad exposure in marketing at national & international level." },
	];
	return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-700 to-teal-500  text-white py-20 text-center px-6">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Bachelor of Business Administration
        </motion.h1>
        <motion.p
          className="max-w-3xl mx-auto text-lg opacity-90"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Preparing students with cutting-edge skills, research knowledge, and
          innovation in technology.
        </motion.p>
      </section>

      {/* Course Features */}
      <section className="max-w-6xl mx-auto py-12 px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          { label: "Total Cost", value: "2,79,962  Tk." },
          { label: "Total Credit Hours", value: "141.0" },
          { label: "Level", value: "Undergraduate" },
          { label: "Semester", value: "January, July" },
          { label: "Duration", value: "4 Years" },
          { label: "Language", value: "English" },
        ].map((item, i) => (
          <motion.div
            key={i}
            className="bg-white p-6 rounded-xl shadow-md text-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.1 }}
          >
            <h3 className="text-lg font-semibold text-gray-700">
              {item.label}
            </h3>
            <p className="text-indigo-600 text-xl font-bold">{item.value}</p>
          </motion.div>
        ))}
      </section>
	   <section className="py-12 bg-gradient-to-r from-green-50 to-green-100">
		  <div className="container mx-auto px-4">
			{/* Section Header */}
			<h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
			  Program Information
			</h2>

			{/* Card */}
			<div className="bg-white shadow-lg rounded-2xl overflow-hidden">
			  {/* Program Title */}
			  <div className="bg-green-600 text-white px-6 py-4">
				<h3 className="text-xl font-semibold">{program.program}</h3>
			  </div>

			  {/* Program Body */}
			  <div className="p-6">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				  <div>
					<p>
					  <span className="font-semibold">Duration:</span>{" "}
					  {program.duration}
					</p>
					<p>
					  <span className="font-semibold">Semester:</span>{" "}
					  {program.semester}
					</p>
					<p>
					  <span className="font-semibold">Credit:</span>{" "}
					  {program.credit}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Admission Fee:</span>{" "}
					  {program.admission}
					</p>
					<p>
					  <span className="font-semibold">Semester Fee:</span>{" "}
					  {program.semester_fee}
					</p>
					<p>
					  <span className="font-semibold">Establishment Fee:</span>{" "}
					  {program.establihsment}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Library Fee:</span>{" "}
					  {program.library}
					</p>
					<p>
					  <span className="font-semibold">Lab Fee:</span>{" "}
					  {program.lab}
					</p>
					<p>
					  <span className="font-semibold">Exam Fee:</span>{" "}
					  {program.exam}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Tuition Fee:</span>{" "}
					  {program.tuition}
					</p>
					<p className="text-lg font-bold text-green-700 mt-4">
					  Total Cost: {program.total}
					</p>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		</section>
	  
      <div className="text-center mb-12">
        <Link to="https://web.bubban.ac.bd/home/apply-online" className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition">
          Apply Now
        </Link>
      </div>

      {/* Program Image */}
      <section className="max-w-6xl mx-auto mb-12 px-6">
        <img
          src="/assets/img/bba.jpg"
          alt="Program Banner"
          className="rounded-2xl shadow-lg"
        />
      </section>

      {/* Overview */}
		<section className="max-w-6xl mx-auto px-6 mb-12 space-y-6">
			<div>
			  <h2 className="text-2xl font-bold text-gray-800 mb-2">Overview</h2>
			  <p className="text-gray-600 leading-relaxed">
			   We are at the doorstep of a new millennium. Managers of the twenty-first century must be strategic thinkers and leaders with integrity who can inspire commitment from others. They must have the ability to manage changes and challenges in a globalized competitive world. In the future, business environmental & other decision making will be much more complex with a diversity of opportunities and threats. There is a significant shortage of innovative and proactive managers in Bangladesh, and the country may not be able to cope with future management demand. The School of Business of this university is committed to educate and train carefully 2 selected young men and women who can meet the demand for managerial excellence both in quality and quantity in the next century. The curriculum of this program is being developed as a continuous basis. There is initially a Committee who prepared the primary curriculum for various programs of the university. But there will be a permanent Curriculum Committee in the department that will be consist of the Chairman of the related department, all teachers of the department, two faculty members of other schools of study and one external expert of the related field from outside the university. The Committee will review and modify the syllabus from time to time.			
			  </p>
			</div>
		</section>
		
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto py-6 px-6"
		>
		<div className="bg-white/10 p-6 rounded-2xl shadow-lg">
		  <h3 className="text-2xl font-semibold text-green-700 mb-3">Vision</h3>
		  <p>
			To be a Valued and Preferred Choice for pursuing Business Management Studies and Generate Competent Management Professionals to become part of the Industry at National and International level.
		  </p>
		</div>
		<div className="bg-white/10 p-6 rounded-2xl shadow-lg">
		  <h3 className="text-2xl font-semibold text-green-700 mb-3">Mission</h3>
		  <ul className="list-disc list-inside space-y-2">
			<li>Endeavour to attract bright and intellectually curious students</li>
			<li>Foster excellence by providing the Quality education in Business Management</li>
			<li>Cultivating the principles of Social Responsibility, Ethics and Spiritual Values among budding managers.</li>
			<li>Developing capable Business and Community leaders.</li>
			<li>To promote self- employment through Entrepreneurship.</li>
		  </ul>
		</div>
		</motion.section>
        
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto py-5 px-6"
		>
		<div className="bg-white/10 p-6 rounded-2xl shadow-lg">
		  <h3 className="text-2xl font-semibold text-green-700 mb-3">Objectives of the Bachelor of Business Administration</h3>
		  <p>
			A Business degree, will help to develop the capacity for independent critical thought and problem-solving, as well as other skills required in responsible positions in a wide variety of organizations and professions.
		  </p>
		</div>
		<div className="bg-white/10 p-6 rounded-2xl shadow-lg">
		  <h3 className="text-2xl font-semibold text-green-700 mb-3">Description of the Program</h3>
		  <p>
			University will offer Four Year Bachelor of Bachelor of Business Administration program which is to be completed in eight semesters. A student will be required to complete a minimum of 40 courses (126 credits) in order to achieve his Bachelor degree, with options to choose the courses from available different titles.
		  </p>
		</div>
		</motion.section>
		
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="max-w-6xl mx-auto py-6 px-6"
		  >
			<h2 className="text-3xl font-bold mb-6">Program Educational Objectives (PEO)</h2>
			<div className="grid md:grid-cols-2 gap-6">
			  {[
				"To embed practical knowledge in the minds of students through industrial visits and various training programs.",
				"To enable the students to gain knowledge over the recent developments in the various areas of Management.",
				"To orient the students in the applied aspects of different advanced business practices.",
				"To equip the students to occupy important positions in Business, Industries and related organizations.",
				"To inspire the students to apply their knowledge gained for the development of society in general.",
			  ].map((peo, i) => (
				<div key={i} className="bg-white/10 p-3 rounded-xl hover:scale-105 transition">
				  <h4 className="font-semibold text-green-700">PEO{i + 1}</h4>
				  <p>{peo}</p>
				</div>
			  ))}
			</div>
		</motion.section>
		
        
		{/* PLO Accordion */}
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="max-w-6xl mx-auto py-6 px-6"
		>
        <h2 className="text-3xl font-bold mb-6">Program Learning Outcomes (PLO)</h2>
        <div className="space-y-4">
          {plos.map((plo, i) => (
            <div
              key={i}
              onClick={() => setOpenPLO(openPLO === i ? null : i)}
              className="bg-white/10 p-3 rounded-xl cursor-pointer hover:bg-white/20 transition"
            >
              <h4 className="flex justify-between items-center text-lg font-semibold text-green-700">
                {`PLO${i + 1}: ${plo.title}`}
                <span>{openPLO === i ? "-" : "+"}</span>
              </h4>
              {openPLO === i && <p className="mt-3 text-gray-700">{plo.text}</p>}
            </div>
          ))}
        </div>
		</motion.section>
      

      

      {/* Entry, Assessment, Graduate Attributes */}
      
       {/* Entry Requirements */}
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="max-w-6xl mx-auto py-6 px-6"
		>
			<h2 className="text-3xl font-bold mb-6">Entry Requirements</h2>
			<ul className="list-decimal list-inside space-y-3 text-gray-700">
			  <li>Total CGPA of SSC+HSC ≥ 6.0, each ≥ 2.5</li>
			  <li>O-Level (5 subjects) + A-Level (2 subjects) → 4 B’s & 3 C’s minimum</li>
			  <li>Freedom fighter quota: total CGPA ≥ 5.0</li>
			  <li>Background: Science or Commerce</li>
			  <li>Admission test required</li>
			</ul>
		</motion.section>

        {/* Assessment Criteria */}
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="max-w-6xl mx-auto py-6 px-6"
		>
			<h2 className="text-3xl font-bold mb-6">Assessment Criteria</h2>
			<ul className="grid md:grid-cols-2 gap-4">
			  {[
				{ title: "Class Test/Assignment", value: 10 },
				{ title: "Attendance", value: 10 },
				{ title: "Class Performance", value: 10 },
				{ title: "Mid-term Exam", value: 20 },
				{ title: "Final Exam", value: 50 },
			  ].map((item, i) => (
				<li key={i} className="bg-white/10 p-5 rounded-xl">
				  <p className="font-semibold">{item.title}</p>
				  <div className="w-full bg-gray-700 h-3 rounded-full mt-2">
					<div
					  className="bg-cyan-500 h-3 rounded-full"
					  style={{ width: `${item.value}%` }}
					></div>
				  </div>
				  <p className="text-sm mt-1">{item.value} Marks</p>
				</li>
			  ))}
			</ul>
		</motion.section>
		 {/* Graduate Attributes */}
		<motion.section
			variants={fadeUp}
			initial="hidden"
			whileInView="visible"
			className="max-w-6xl mx-auto py-6 px-6"
		>
        <h2 className="text-3xl font-bold mb-6">Graduate Attributes</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            "Comprehensive knowledge and understanding of theoretical aspects of hospitality and tourism.",
            "Creative, analytical, interpretive, reflective and critical thinking ability on various situations.",
            "Corporate levels problem solving skills.",
            "Academic integrity and ethically-based research skills.",
            "Knowledge on business (hotels, restaurants, travel agency, airlines etc.) planning, set up, follows up, entrepreneurship and start up idea, sustainability.",
            "Acceptance and tolerance of diverse cultures.",
            "Teamwork and effective communication skills in dealing with business and organizational related activities.",
            "Knowledge on daily based activities marketing, accounting, finance, management activities, front office, house- keeping, food & beverage operations, tour guiding of hotels, restaurants, resorts etc.",
			"Ethnic and intercultural competency.",
			"Responsible for their own behavior, their future and their wellbeing.",
			"Advanced knowledge on national and international business setting.",
          ].map((job, i) => (
            <div key={i} className="bg-white/10 p-6 rounded-xl shadow-lg hover:scale-105 transition">
              <h4 className="font-semibold text-cyan-700">{job}</h4>
            </div>
          ))}
        </div>
		</motion.section>
		

      {/* Semester Wise Courses */}
      <section className="max-w-6xl mx-auto px-6 pb-16">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Semester-wise Courses
        </h2>

        {Object.entries(data).map(([semester, courses], idx) => (
        <div
          key={idx}
          className="mb-6 border border-green-700 rounded-xl shadow-sm bg-white overflow-hidden"
        >
          {/* Accordion Header */}
          <button
            onClick={() => toggleSemester(semester)}
            className="w-full flex justify-between items-center px-6 py-4  font-semibold text-lg"
          >
            {semester}
            <span>{openSemester === semester ? "▲" : "▼"}</span>
          </button>

          {/* Accordion Body */}
          <AnimatePresence initial={false}>
            {openSemester === semester && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="p-6">
                  <table className="w-full border rounded-lg overflow-hidden shadow-md">
                    <thead className="bg-green-600 text-white">
                      <tr>
                        <th className="p-3 text-left">SL</th>
                        <th className="p-3 text-left">Course Code</th>
                        <th className="p-3 text-left">Course Title</th>
                        <th className="p-3 text-left">Credit Hours</th>
                        <th className="p-3 text-left">Pre-requisite</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {courses.map((course) => (
                        <tr key={course.sl}>
                          <td className="p-3">{course.sl}</td>
                          <td className="p-3">{course.actual_code}</td>
                          <td className="p-3">{course.course_title}</td>
                          <td className="p-3">{course.credit_hours}</td>
                          <td className="p-3">
                            {course.pre_requisite || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
      </section>
    </div>
  );
}
